import { request } from '@umijs/max';

export async function queryRoleService(params: any) {
  return request(`/bcare/role/query/condition`, {
    params,
  });
}
